module.exports = __webpack_public_path__ + "static/img/logo-1.bd29c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-1.png
// module id = s+4m
// module chunks = 51